module.exports = __webpack_public_path__ + "img/shield.18fc89b5.svg";